import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const S = {
  QuestionBlock: styled.div.attrs(({ position, size }) => ({
    style: {
      top: `${position.y}%`,
      left: `${position.x}%`,
      width: `${size.width}%`,
      height: `${size.height}%`,
    },
  }))`
    position: absolute;
    border: 2px solid ${({ error, theme }) => theme.palette.status[error ? 'error' : 'note'].main};
    border-radius: 2px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.24);
  `,
  QuestionNumber: styled.div`
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(calc(-100% - 2px), calc(-100% - 2px));
    padding: ${({ large }) => (large ? '3px 6px' : '2px 4px')};
    border-radius: ${({ large }) => (large ? '12px 12px 0 12px' : '8px 8px 0 8px')};
    color: ${({ theme }) => theme.palette.primary.contrastText};
    background-color: ${({ error, theme }) => theme.palette.status[error ? 'error' : 'note'].main};
    font-size: ${({ large, theme }) => theme.typography.pxToRem(large ? 13 : 10)};
    font-weight: 700;
    line-height: ${({ large }) => (large ? 1.54 : 1.4)};
    box-shadow: ${({ large }) => (large ? '0 1px 4px 0 rgba(0, 0, 0, 0.32);' : '0 1px 2px 0 rgba(0, 0, 0, 0.32)')};
  `,
};

const Question = ({ error, large, question }) => (
  <S.QuestionBlock
    number={question.number}
    position={question.position || { x: question.offsetX, y: question.offsetY }}
    required={question.required}
    size={question.size || { width: 0, height: 0 }}
    error={error}
    large={large}
  >
    <S.QuestionNumber error={error} large={large}>
      {`Q${question.number}${question.required ? '*' : ''}`}
    </S.QuestionNumber>
  </S.QuestionBlock>
);

Question.propTypes = {
  error: PropTypes.bool,
  large: PropTypes.bool,
  question: PropTypes.shape({
    number: PropTypes.number,
    position: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number,
    }),
    size: PropTypes.shape({
      width: PropTypes.number,
      height: PropTypes.number,
    }),
    required: PropTypes.bool,
    offsetX: PropTypes.number,
    offsetY: PropTypes.number,
  }).isRequired,
};

Question.defaultProps = {
  error: false,
  large: false,
};

export default Question;
